/*
  Puts each card from sections/kl-article-ad-cards.liquid where its marker is in the article.

  The copy carries one marker per card, alone in its own paragraph, reading [ad]meta-product[ad].
  They were written for the previous theme and are still in every article. This file finds them
  and swaps each for the next card the section rendered; the section decides which products
  those are and what they look like, and this file decides nothing but position.

  A marker with no card left, and a marker naming something this file cannot draw, are both
  removed rather than left on the page. They are instructions to a theme, not writing, and a
  reader should never see one.
*/

/* Prefixed: every authored script shares one global scope, so a bare TOKEN_PATTERN here would
   collide with the same name in another kl-*.js and kill whichever loads second. */
const KL_ARTICLE_AD_MARKER_PATTERN = /^\[ad\](.+)\[ad\]$/;
const KL_ARTICLE_AD_METAFIELD_MARKER = 'meta-product';

/* Pure: takes an element, returns what its marker names, or null when it is not a marker.
   The whole paragraph has to be the marker — a paragraph that merely mentions one is prose,
   which is the same test the previous theme made when it split the body. */
function readArticleAdMarker(element) {
  const markerMatch = element.textContent.trim().match(KL_ARTICLE_AD_MARKER_PATTERN);

  if (!markerMatch) return null;

  return markerMatch[1].trim();
}

function placeArticleAdCards(holderElement) {
  const contentElement = document.querySelector('[data-kl-article-content]');

  if (!contentElement) return;

  const cardElements = [...holderElement.querySelectorAll('[data-kl-article-ad-card]')];

  if (cardElements.length === 0) return;

  let nextCardIndex = 0;

  /* querySelectorAll returns a static list, so replacing and removing paragraphs as we go
     cannot make the walk skip one. */
  contentElement.querySelectorAll('p').forEach((paragraphElement) => {
    const markerName = readArticleAdMarker(paragraphElement);

    if (markerName === null) return;

    if (markerName !== KL_ARTICLE_AD_METAFIELD_MARKER) {
      console.debug('kl-article-ad-cards: marker names something other than the metafield list', {
        markerName,
      });
      paragraphElement.remove();
      return;
    }

    const cardElement = cardElements[nextCardIndex];

    if (!cardElement) {
      console.debug('kl-article-ad-cards: more markers than products on this article', {
        cardCount: cardElements.length,
      });
      paragraphElement.remove();
      return;
    }

    nextCardIndex += 1;
    paragraphElement.replaceWith(cardElement);
  });
}

document.querySelectorAll('[data-kl-article-ad-cards]').forEach(placeArticleAdCards);
